import { GetPatientDetailsSchema } from '@montugroup/pms-api-contracts';
import { z } from 'zod';

export const schema = GetPatientDetailsSchema.shape.identificationInfo
  .unwrap()
  .shape.attributes.pick({
    medicareNumber: true,
    medicareExpDate: true,
    medicareRefNumber: true
  })
  .partial()
  .extend({
    medicareNumber: z
      .string({ message: 'Medicare number is required.' })
      .optional()
      .nullable()
      .refine((number) => !number || /^[0-9]{10}$/.test(number), {
        message: 'Medicare number must be exactly 10 digits long and contain only numbers.'
      }),
    medicareExpDate: z
      .string({ message: 'Medicare expiry date is required.' })
      .optional()
      .nullable()
      .refine((value) => !value || /^(0[1-9]|1[0-2])\/\d{4}$/.test(value), {
        message: 'Expiry date must be in MM/YYYY format.'
      }),
    medicareRefNumber: z
      .union([z.number(), z.string(), z.null()])
      .optional()
      .transform((val) => {
        if (val === '' || val === null || val === undefined) {
          return null;
        }
        return typeof val === 'string' ? Number(val) : val;
      })
      .nullable()
  })
  .superRefine((data, ctx) => {
    // If medicareNumber exists, both expDate and refNumber must also exist
    if (data.medicareNumber) {
      if (!data.medicareExpDate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Medicare expiry date is required when Medicare number is provided',
          path: ['medicareExpDate']
        });
      }

      if (data.medicareRefNumber === undefined || data.medicareRefNumber === null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Medicare reference number is required when Medicare number is provided',
          path: ['medicareRefNumber']
        });
      }
    }
  });

export type MedicareFormFields = z.infer<typeof schema>;
